import React, { useRef, useState } from "react";
import "./index.scss";

export const Slider = props => {
  const { images } = props;

  const ulRef = useRef();
  const liRef = useRef();
  const fullImageRef = useRef();

  const [index, setIndex] = useState(0);

  function showFullImage({ src, alt }) {
    fullImageRef.current.style.display = `block`;
    fullImageRef.current.children[0].src = `${src}`;
    fullImageRef.current.children[0].alt = `${alt}`;
  }

  function closeFullImage() {
    fullImageRef.current.style.display = "none";
  }

  function moveRight() {
    const idx = index + 1 >= images.length ? 0 : index + 1;
    setIndex(idx);
    const imageWidth = liRef.current.clientWidth;
    ulRef.current.style.transform = `translateX(-${imageWidth * idx}px)`;
  }
  function moveLeft() {
    const idx = index - 1 < 0 ? images.length - 1 : index - 1;
    setIndex(idx);
    const imageWidth = liRef.current.clientWidth;
    ulRef.current.style.transform = `translateX(${imageWidth * -idx}px)`;
  }

  return (
    <div id="slider">
      <span onClick={moveRight} className="slider__control_next">
        {">>"}
      </span>
      <span onClick={moveLeft} className="slider__control_prev">
        {"<<"}
      </span>

      <ul ref={ulRef}>
        {images.map(({ src, alt }, idx) => (
          <li onClick={() => showFullImage({ src })} ref={liRef} key={idx}>
            <img src={src} alt={alt} />
          </li>
        ))}
      </ul>

      <div ref={fullImageRef} className="slider__full_image_container">
        <img alt="_" />
        <span onClick={closeFullImage}>X</span>
      </div>

      <span
        className="slider__complete_image"
        onClick={() => showFullImage(images[index])}
      >
        Ver imagen
      </span>
    </div>
  );
};
